import React from 'react';
import './Menu.css';





const staticButtons = [
  { label: 'Info', icon: null, color: '#0099cc', key: 'info' },
  { label: 'Cómo funciona la app', icon: null, color: '#0099cc', key: 'como-funciona' },
  { label: 'Relajación Profunda', icon: 'play', color: '#669a2f', key: 'relajacion' },
  { label: 'SonoTerapia', icon: 'sound', color: '#ff2fb3', key: 'sonoterapia' },
  { label: 'FAQ', icon: null, color: '#0099cc', key: 'faq' },
  { label: 'Acerca de Braineka', icon: null, color: '#0099cc', key: 'acerca' },
  { label: 'Contacta tu Neuroterapeuta', icon: '🧠', color: '#0099cc', key: 'contacta' },
];

export default function Menu({ tratamientos = [], logotema, onInfo, onComoFunciona, onRelajacion, onSonoTerapia, onTratamiento, onFaq, onAcerca, onContacta, onLogout, isLoggedIn }) {
  return (
    <div className="menu-container">
      {/* Siempre mostrar el logo de Braineka arriba de los botones */}
      <img src="/logo.png" alt="Braineka logo" className="menu-logotema" style={{ width: 56, height: 56, margin: '0 auto 10px auto', display: 'block' }} />
      <div className="menu-buttons">
        {staticButtons.map((btn) => {
          if (btn.key === 'info') return null; // Info por tratamiento, no global
          if (btn.key === 'como-funciona') return <button key={btn.key} className="menu-btn" style={{ background: btn.color }} onClick={onComoFunciona}>{btn.label}</button>;
          if (btn.key === 'relajacion') return <button key={btn.key} className="menu-btn menu-btn-play" style={{ background: btn.color }} onClick={onRelajacion}>{btn.label}</button>;
          if (btn.key === 'sonoterapia') return <button key={btn.key} className="menu-btn menu-btn-sonoterapia" style={{ background: btn.color }} onClick={onSonoTerapia}>{btn.label}</button>;
          if (btn.key === 'faq') return <button key={btn.key} className="menu-btn" style={{ background: btn.color }} onClick={() => window.location.href='/faq'}>{btn.label}</button>;
          if (btn.key === 'acerca') return <button key={btn.key} className="menu-btn" style={{ background: btn.color }} onClick={onAcerca}>{btn.label}</button>;
          if (btn.key === 'contacta') return <button key={btn.key} className="menu-btn" style={{ background: btn.color }} onClick={() => window.location.href='/contacta'}>{btn.label}</button>;
          return null;
        })}
        {tratamientos.length > 0 && (
          <div style={{ marginTop: 16, width: '100%' }}>
            <div style={{ fontWeight: 600, marginBottom: 8, color: '#f18618' }}>Ejecuta tratamientos disponibles</div>
            {tratamientos.map(t => (
              <div key={t.id} style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 10 }}>
                <button
                  className="menu-btn menu-btn-info"
                  style={{
                    background: '#0099cc',
                    color: '#fff',
                    minWidth: 36,
                    height: 28,
                    fontSize: 11,
                    fontWeight: 600,
                    borderRadius: 6,
                    padding: '0 8px',
                    lineHeight: '24px',
                    alignSelf: 'flex-end',
                    boxShadow: '0 1px 2px #0001',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => onInfo && onInfo(t.id)}
                  aria-label={`Info ${t.nombre}`}
                >
                  {`Info ${t.nombre}`}
                </button>
                <button
                  className="menu-btn menu-btn-tratamiento"
                  style={{ background: '#f18618', color: '#fff', width: '100%', display: 'flex', alignItems: 'center', gap: 10 }}
                  onClick={() => onTratamiento && onTratamiento(t.id)}
                >
                  {t.carpeta ? (
                    <img
                      src={`/Tratamientos/${t.carpeta}/logotema.png`}
                      alt="logotema"
                      style={{ width: 28, height: 28, borderRadius: 6, background: '#fff', marginRight: 6, objectFit: 'cover' }}
                    />
                  ) : (
                    <img src="/favicon.ico" alt="icono" style={{ width: 28, height: 28, borderRadius: 6, background: '#fff', marginRight: 6 }} />
                  )}
                  <span style={{ flex: 1, textAlign: 'left' }}>{t.nombre}</span>
                </button>
              </div>
            ))}
          </div>
        )}
        {isLoggedIn && (
          <button className="menu-btn menu-btn-logout" onClick={onLogout} style={{ background: 'linear-gradient(90deg,#ff512f 0%,#dd2476 100%)', marginBottom: 12, fontWeight: 700, fontSize: '1.1rem' }}>Cerrar sesión</button>
        )}
      </div>
    </div>
  );
}
